import { useQuery } from '@tanstack/react-query';
import type { CustomerReferralView } from '@dunea/shared';
import { apiGetCustomerReferral } from '~/lib/api/marketplace';
import { CopyField } from '~/components/workbench/tools/payments/ui';
import { creditsLabel } from '~/components/workbench/tools/marketplace/marketplace-model';

/** "Invite a business": your referral link, the credits both sides get, and how it's going. */
export function InviteBusinessCard() {
  const { data, isLoading, isError, refetch } = useQuery<CustomerReferralView>({
    queryKey: ['customer-referral'],
    queryFn: apiGetCustomerReferral,
    staleTime: 60_000,
  });

  return (
    <div>
      <div className="ui-caption mb-2.5 mt-6.5">Invite a business</div>
      <div className="space-y-3 rounded-xl border border-hairline bg-raised p-4">
        {isLoading ? (
          <div className="h-[72px] animate-pulse rounded-lg bg-sunken" />
        ) : isError || !data ? (
          <div className="flex items-center justify-between gap-3 text-[12px] text-muted">
            Couldn't load your invite link.
            <button type="button" onClick={() => void refetch()} className="ui-btn-secondary">
              Retry
            </button>
          </div>
        ) : (
          <>
            <p className="text-[12.5px] leading-relaxed text-secondary">
              You both get {creditsLabel(data.rewardCredits)} once their first payment clears.
            </p>
            <CopyField value={data.link} />
            <div className="flex flex-wrap gap-x-4 gap-y-1 text-[11.5px] text-muted [font-variant-numeric:tabular-nums]">
              <span>{data.invited} invited</span>
              <span>{data.rewarded} rewarded</span>
              <span>{creditsLabel(data.creditsEarned)} earned</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
